import React from 'react'

function Footer() {
  return (
    <footer className='container-fluid mt-5 py-4 bg-light d-flex flex-column'>
        Report bugs or ask for features?
        <a href="tel:780-915-9731"> Call Me : 780-915-9731</a>
        <a href="mailto:jessjoemanoj@gmail.com"> Email me : jessjoemanoj@gmail</a>

    </footer>
  )
}

export default Footer